import {renderMarkRule, renderNodeRule} from 'datocms-structured-text-to-plain-text'
import {isLink, isParagraph} from 'datocms-structured-text-utils'
import {Fragment} from 'react'
import {StructuredText} from 'react-datocms/structured-text'
import {DatoConstant} from '~/cms/components/Constants/DatoConstant'
import DisclaimerLink from '~/cms/components/SingleLineStructuredText/DisclaimerLink'
import {type HgWYSIWYGType} from '~/design-system/hg/components/HgWYSIWYG'
import {
  handleBoldMark,
  handleIOMark,
  handleSuperscriptMark,
} from '../../_utils/markRules'
import {handleLinkNode, handleParagraphNode} from '../../_utils/nodeRules'
import {type WysiwygMultiLineStructuredTextFragment} from './_generated/fragment.graphql'
import {safeUnreachableCase} from '~/utils/unreachableCase'
import {DatoRecordLink} from '../DatoRecordLink'

type WYSIWYGMultiLineStructuredTextProps = {
  data?: WysiwygMultiLineStructuredTextFragment | null
  wysiwygType: HgWYSIWYGType
}

export function WYSIWYGMultiLineStructuredText({
  data,
  wysiwygType,
}: WYSIWYGMultiLineStructuredTextProps) {
  if (!data) return null
  return (
    <Fragment key={data.id}>
      <StructuredText
        customMarkRules={[
          renderMarkRule('io-font', handleIOMark),
          renderMarkRule('strong', handleBoldMark),
          renderMarkRule('superscript', handleSuperscriptMark),
        ]}
        customNodeRules={[
          renderNodeRule(isLink, handleLinkNode),
          renderNodeRule(isParagraph, nodeProps =>
            handleParagraphNode({...nodeProps, wysiwygType})
          ),
        ]}
        renderLinkToRecord={({record, children: datoChildren}) => {
          switch (record.__typename) {
            case 'ConstantRecord':
              return (
                <DatoRecordLink datoChildren={datoChildren}>
                  <DatoConstant data={record} />
                </DatoRecordLink>
              )
            case 'DisclaimerRecord':
              return <DisclaimerLink {...record} text={record.text} />
            default:
              return safeUnreachableCase(record, null)
          }
        }}
        data={data.text}
      />
    </Fragment>
  )
}
